<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>
            {{ source.title }}
            <open-on-site
              :source-route="source.route"
            />
            <button class="btn btn-danger btn-sm" @click="$_deleteEntity(`media/audio-albums/${source.id}`)">
              Delete
              <span ref="deleteBtnLoader" class="btn-loader" style="display: none;" />
            </button>
          </h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
          <router-link
            class="btn btn-primary btn-sm pull-right"
            :to="{ name: 'AlbumManageTracks', params: { id: $route.params.id }}"
          >
            Manage Tracks
          </router-link>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Body</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Cover</label>
                  <div class="col-md-10">
                    <image-uploader
                      :uploaded-img-url="source.cover ? source.cover.public_url : null"
                      :removable="false"
                      @changeFile="$_coverChange"
                      @returnedOldFile="coverRemove"
                      @existingFileRemoved="coverRemove"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Collection *</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.collection"
                      :default-options="defaultOptions.audioCollections"
                      :search-function="collectionSearch"
                      label="name"
                      :start-val="entity.collection"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured.section_id" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured.section_id && entity.featured.section_id > 0" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featured.featured_body" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        :already-choosen-refs="entity.loadedReferences"
        @changeRefs="$_changeRefs"
      />

      <terms
        :already-choosen-terms="entity.terms"
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Audio Album has modified successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import SelectRemote from '@/global/components/SelectRemote';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import CommonPageMixin from '@/mixins/CommonPageMixin';

export default {
  name: 'AlbumEdit',

  components: {
    referencer: Referencer,
    terms: Terms,
    'select-remote': SelectRemote,
    'open-on-site': OpenOnSiteButton,
  },

  mixins: [EditPageMixin, DefaultOptionsRequests, CommonPageMixin],

  data() {
    return {
      coverWithoutChanges: true,
    };
  },

  mounted() {
    this.$_getDefaultCollections();
  },

  methods: {
    collectionSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}media/audio-albums/collections?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          context.options = response.data;
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    $_coverChange(file) {
      this.coverWithoutChanges = false;
      this.entity.cover = file;
    },
    coverRemove() {
      this.entity.cover = null;
    },
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Collection', value: this.entity.collection, type: 'required' },
        { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' },
      ]);
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/audio-albums/${this.$route.params.id}`, {
        params: {
          with: ['references', 'terms', 'cover', 'path_alias', 'collection', 'featured'],
        },
      }).then((response) => {
        this.source = this.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'cover')) {
          this.source.cover = null;
        }
        this.entity = _.cloneDeep(this.source);
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
      }).catch((error) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting album request' });
        console.log('Error in get audio album query', error);
      });
    },
    saveCoverRequest() {
      const postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}media/audio-albums/${this.$route.params.id}/cover`,
        postFormData,
      );
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      postFormData.append('collection', this.entity.collection ? this.entity.collection.id : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}media/audio-albums/${this.$route.params.id}`,
        postFormData,
      );
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (this.entity.cover && !this.coverWithoutChanges) {
        axios.all([this.saveCoverRequest(), this.saveRequest()]).then(axios.spread((cover, entity) => {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            this.$_successSave();
          } else {
            this.$_showError('Error in data saving');
          }
        }));
      } else {
        this.saveRequest().then(() => {
          this.$_successSave();
        }).catch((error) => {
          this.$_errorSave(error);
          console.error('Error in update audio album query', error);
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?43b1d181